import React, {useState, useEffect} from 'react'
import Image from '../Image/Image'
import Icons from '../../../components/Icons'
import styled from 'styled-components'
import './Building.css'
import {fetchBuilding} from '../../../utils/buildings'
import MediaQuery from 'react-responsive'
import { useReactToPrint } from 'react-to-print';

const StyledContainer = styled.div`
  min-height: 100%;
  width: 100%;
  display: grid;
  grid-template-rows: auto 1fr 1fr auto;
  grid-template-columns: 320px;
  grid-template-areas: 'image' 'name' 'location' 'ada';
  box-sizing: border-box;

  @media (max-width: 1024px) {
    grid-template-columns: 255px;
  }

  @media (max-width: 768px) {
    grid-template-rows: 19px 60px 65px auto;
    grid-template-columns: 125px calc(100vw - 125px);
    grid-template-areas: 'expand expand' 'image name' 'image location' 'ada ada';
    border-top: 1px solid #13294b;
  }

  @media (max-width: 420px) {
    width: 100%;
    grid-template-rows: 19px 30px auto auto;
    grid-template-columns: 80px calc(100vw - 80px);
  }
  
  @media print {
	grid-template-columns: 100vh;
	padding-top: 24px;
	padding-bottom: 24px;
	a { text-decoration: none !important; }
  }
`

/* 
  @media print {
	grid-template-columns: 100vh;
	padding-top: 24px;
	padding-bottom: 24px;
	a { text-decoration: none !important; }
	page: auto;
  }
	@page {
		size: portrait;
		margin: 0.5in;
	}
 */

const StyledName = styled.h1`
  font-size: 22px;
  font-weight: bold;
  grid-area: name;
  box-sizing: border-box;
  padding: 10px 24px 0px 24px;
  border-bottom: 1px solid #f3f5fb;
  letter-spacing: -0.3px;

  @media (max-width: 1024px) {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    margin: auto 0px;
    padding: 0 8px 0 24px;
    border-bottom: 0;
  }

  @media (max-width: 420px) {
    font-size: 16px;
    padding: 0;
    border-bottom: 1px solid #f3f5fb;
    margin: 0 8px 0 24px;
  }
`

const StyledLocationContainer = styled.div`
  grid-area: location;
  box-sizing: border-box;
  padding: 10px 24px 0px 24px;
  border-bottom: 1px solid #f3f5fb;
  margin: 0px 20px 0px 3px;
  
  :focus-within {
	 outline: 3px solid #FF9900;
  }
  
  @media (max-width: 768px) {
    margin: 0;
    padding: 0 8px 0 24px;
    border-bottom: 0;
  }
  
  @media print {
	  padding-top: 5px;
  }
`

const StyledLocationText = styled.div`
  font-size: 16px;
  color: #52555B;
  letter-spacing: -0.3px;
  text-decoration: none;
  
   @media (max-width: 420px) {
	font-size: 14px;
  }
  
  @media print {
	  color: black;
	  font-weight: bold;
  }
`

const StyledAddress = styled.div`
  font-size: 16px;
  color: #52555B;
  letter-spacing: -0.3px;
  text-decoration: none;
  
  @media (max-width: 420px) {
	font-size: 14px;
  }
  
  @media print {
	  color: black;
	  font-weight: bold;
  }
`
// TODO: Used in equipment detail
const StyledImageContainer = styled.div`
  width: 320px;
  height: 320px;
  grid-area: image;

  @media (max-width: 1024px) {
    width: 255px;
    height: 255px;
  }

  @media (max-width: 768px) {
    width: 125px;
    height: 125px;
  }

  @media (max-width: 420px) {
    width: 80px;
    height: 80px;
    box-sizing: border-box;
    margin-top: 0;
  }
  
  @media print {
	  padding-left: 24px;
  }
`

const StyledExpandContainer = styled.button`
  grid-area: expand;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
  background-color: white;
  width: 100%;
  padding-top: 2px;
  border: 0;
  
  :focus {
	 outline: 1px solid #FF9900;
  }
`

const ArrowIconsUp = styled(Icons)`
  padding-bottom: 4px;
  display: block;
`

const ArrowIconsDown = styled(Icons)`
  padding-bottom: 4px;
  display: block;
`

// TODO: same as eq
const StyledDetailContainer = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;
`
// TODO: same as eq
const LocationIcon = styled(StyledDetailContainer)`
  width: 30px;
  
  @media print {
	  display: none;
  }
`
const StyledAdaContainer = styled.div`
  font-size: 16px;
  grid-area: ada;
  box-sizing: border-box;
  padding: 15px 24px 15px 24px;
  border-bottom: 1px solid #f3f5fb;
  background-color: white;

  @media (max-width: 768px) {
    margin: 0;
    padding: 0 10px 0 10px;
    border-bottom: 0;
    display: none;
    height: 1002px;
    width: 100%;
  }
`
const AdaEntryTitle = styled.h2`
  font-size: 20px;
  font-weight: bold;
  padding-top: 0px;
`

const AdaEntry = styled.div`
`

const AdaParkTitle = styled.h2`
  font-size: 20px;
  font-weight: bold;
  padding-top: 15px;
`

const AdaPark = styled.div`
`

const AdaRouteTitle = styled.h2`
  font-size: 20px;
  font-weight: bold;
  padding-top: 15px;
`

const AdaRoute = styled.div`
`

const AdaRestrmTitle = styled.h2`
  font-size: 20px;
  font-weight: bold;
  padding-top: 15px;
`

const AdaRestrm = styled.div`
`

const AdaElevTitle = styled.h2`
	font-size: 20px;
	font-weight: bold;
	padding-top: 15px;
`

const AdaElev = styled.div`
`

const AdaAldTitle = styled.h2`
  font-size: 20px;
  font-weight: bold;
  padding-top: 15px;
`

const AdaAld = styled.div`
`

const PrintContainer = styled(StyledDetailContainer)`
	width: 65px;
	padding-left: 15px;
	padding-top: 25px;
	@media print {
		display: none;
	}
`
const PrintButton = styled.button`
	width: 32;
	height: 34;
	padding: 3px 3px 0 3px;
	border: none;
	background: none;
	cursor: pointer;
	@media print {
	display: none;
	}

	:focus {
		outline: 3px solid #FF9900 !important;
	}
`

const Building = props => {
  let initialState = {
    name: '',
    address: '',
    url: null,
    cityName: '',
    cityStateId: '',
    adaCommentsEntry: '',
    adaCommentsPark: '',
    adaCommentsRoute: '',
    adaCommentsRestrm: '',
    adaCommentsElev: '',
    adaCommentsAld: '',
	mapAddress: ''
  }
  
	const componentRef = document.querySelectorAll("*[class^=\"Building__StyledContainer\"]")
	const handlePrint = useReactToPrint({
		content: () => componentRef[0],
	});
	
  const [building, setBuilding] = useState(initialState)
  let {name, address1, url, cityName, cityStateId, adaCommentsEntry, adaCommentsPark, adaCommentsRoute, adaCommentsRestrm, adaCommentsElev, adaCommentsAld, mapAddress} = building
  if (name && props.options["blId"]) {
		name = name + " [" + props.options["blId"] + "]"
  }
  
  mapAddress = "https://maps.google.com/?q=" + address1 + ", " + cityName + ", " + cityStateId

  const {blId} = props.options

  useEffect(
    () => {
      fetchBuilding({blId}).then(building => {
        setBuilding(building)
        document.getElementsByTagName("TITLE")[0].innerHTML = "UIUC Facility Access Maps | " + building.name
      })
    },
    [blId]
  )
/* 
    <StyledContainer>
		<style type="text/css" media="print">{"\ @page {\ size: portrait;\ margin: 0.5in;\ }\ a {\ text-decoration: none !important;\ }\ "}</style>
 */
  return (
    <StyledContainer>
		<style type="text/css" media="print">{"\
		  @page {\ size: portrait;\
		  margin: 0.25in !important;\ }\
		"}</style>
     <MediaQuery maxWidth={768}>
	      <StyledExpandContainer id="expand-cont" onClick={props.onExpand} aria-expanded="false" aria-controls="ada-container">
	        <ArrowIconsUp icon= "UP_ARROW" />
	        <ArrowIconsDown icon= "DOWN_ARROW" />
	      </StyledExpandContainer>
	      <StyledImageContainer>
	        <Image url={url} placeholder={false} />
	      </StyledImageContainer>
	      <StyledName id="BldgName">{name}</StyledName>
	      <StyledAdaContainer id="ada-container" aria-hidden="true" aria-label="show textual accessibility information">
	      	<AdaEntryTitle>Accessible Entries</AdaEntryTitle>
			<AdaEntry dangerouslySetInnerHTML={{__html: adaCommentsEntry}}></AdaEntry>
			<AdaParkTitle>Parking</AdaParkTitle>
			<AdaPark dangerouslySetInnerHTML={{__html: adaCommentsPark}}></AdaPark>
			<AdaRouteTitle>Interior Access Route</AdaRouteTitle>
			<AdaRoute dangerouslySetInnerHTML={{__html: adaCommentsRoute}}></AdaRoute>
			<AdaRestrmTitle>Restrooms</AdaRestrmTitle>
			<AdaRestrm dangerouslySetInnerHTML={{__html: adaCommentsRestrm}}></AdaRestrm>
			<AdaElevTitle>Elevators</AdaElevTitle>
			<AdaElev dangerouslySetInnerHTML={{__html: adaCommentsElev}}></AdaElev>
			<AdaAldTitle>Assistive Listening Systems</AdaAldTitle>
			<AdaAld dangerouslySetInnerHTML={{__html: adaCommentsAld}}></AdaAld>
		  </StyledAdaContainer>
	      <StyledLocationContainer>
			<a href={mapAddress} target="_blank">
				<StyledDetailContainer>
				  <LocationIcon>
					<Icons icon="LOCATION" />
				  </LocationIcon>
				  <div>
					<StyledLocationText>{address1}</StyledLocationText>
					<StyledAddress>
					  {cityName}, {cityStateId}
					</StyledAddress>
				  </div>
				</StyledDetailContainer>
			</a>
	      </StyledLocationContainer>
	 </MediaQuery>
	 <MediaQuery minWidth={769}>
	   <StyledImageContainer>
	     <Image url={url} placeholder={false} />
	   </StyledImageContainer>
		<StyledName id="BldgName">{name}</StyledName>
		<StyledDetailContainer>
		   <StyledLocationContainer title="Display Address in Google Maps">
				<a href={mapAddress} target="_blank">
					<StyledDetailContainer>
					  <LocationIcon>
						<Icons icon="LOCATION" />
					  </LocationIcon>
					  <div>
						<StyledLocationText>{address1}</StyledLocationText>
						<StyledAddress>
						  {cityName}, {cityStateId}
						</StyledAddress>
					  </div>
					</StyledDetailContainer>
				</a>
		   </StyledLocationContainer>
			  <PrintContainer>
				<PrintButton id="printBuildingInfo" title="Print Building Information" onClick={handlePrint} aria-hidden="true">
					<svg id="svg-print-bldg-icon" height="24" viewBox="0 0 2048 2048" fill="#3e4044" stroke="#3e4044" stroke-width="48">
						<path id="svg-print-icon-path" d="M1920 768q26 0 49 10t41 27 28 41 10 50v896h-512v256H512v-256H0V896q0-26 10-49t27-41 41-28 50-10h384V0h1024v768h384zm-1280 0h768V128H640v640zm768 640H640v512h768v-512zm512-512H128v768h384v-384h1024v384h384V896zM320 1024q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19z"/>
					</svg>
				</PrintButton>
			  </PrintContainer>
		</StyledDetailContainer>
	   <StyledAdaContainer id="ada-container">
	   	<AdaEntryTitle>Accessible Entries</AdaEntryTitle>
			<AdaEntry dangerouslySetInnerHTML={{__html: adaCommentsEntry}}></AdaEntry>
			<AdaParkTitle>Parking</AdaParkTitle>
			<AdaPark dangerouslySetInnerHTML={{__html: adaCommentsPark}}></AdaPark>
			<AdaRouteTitle>Interior Access Route</AdaRouteTitle>
			<AdaRoute dangerouslySetInnerHTML={{__html: adaCommentsRoute}}></AdaRoute>
			<AdaRestrmTitle>Restrooms</AdaRestrmTitle>
			<AdaRestrm dangerouslySetInnerHTML={{__html: adaCommentsRestrm}}></AdaRestrm>
			<AdaElevTitle>Elevators</AdaElevTitle>
			<AdaElev dangerouslySetInnerHTML={{__html: adaCommentsElev}}></AdaElev>
			<AdaAldTitle>Assistive Listening Systems</AdaAldTitle>
			<AdaAld dangerouslySetInnerHTML={{__html: adaCommentsAld}}></AdaAld>
		</StyledAdaContainer>
	 </MediaQuery>
    </StyledContainer>
  )
}

export default Building
